module.exports = __webpack_public_path__ + "02c229de4d98ea1668384d2ed4cc558d.svg";